import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { isEventDetailsEnabled } from '../utils/IsEventDetailsEnabled';
export function SectionItemEventDetails({ competitionName, sportId, startDateTime, }) {
    const eventStartTime = useMemo(() => dayjs(startDateTime).format('HH:mm'), [startDateTime]);
    if (!isEventDetailsEnabled(sportId)) {
        return null;
    }
    return (React.createElement("div", { className: "WhSearch-SectionItem__event-details" },
        eventStartTime,
        " ",
        competitionName));
}
//# sourceMappingURL=SectionItemEventDetails.js.map